var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerAxle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 16,
    viewBox: "0 0 64 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44211 6.08838H56.5355V11.3555H5.42188L5.44211 6.08838Z",
    fill: "#D1D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81575 8.83594H7.0625V6.08268L9.81575 8.83594Z",
    fill: "#999A99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44211 8.83643H56.5355V11.3555H5.42188L5.44211 8.83643Z",
    fill: "#1A1816"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27065 5.25996H7.06803V12.1875H5.26953L5.27065 5.25996Z",
    fill: "#1A1816"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02261 11.3477H6.71442V8.27655H6.44531V6.35183L7.02261 6.93627V11.3477Z",
    fill: "#171514"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5306 8.83594H53.7773L56.5306 6.08268V8.83594Z",
    fill: "#999A99"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5312 12.1875H58.3297V5.25996H56.5312V12.1875Z",
    fill: "#1A1816"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5847 9.10547H58.2188V6.43854L58.8627 5.79712V8.82696H58.5847V9.10547Z",
    fill: "#2D2C2C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.886 11.3477H56.5781V6.93627L57.1554 6.35183V8.27655H56.886V11.3477Z",
    fill: "#171514"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1523 12.1914H58.973V5.26387H57.1523V12.1914Z",
    fill: "#D1D0D0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8867 12.1914H58.9739V8.28356H56.8867V12.1914Z",
    fill: "#1A1816"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2188 14.3047H62.8371V3.15845H58.2188V14.3047Z",
    fill: "#5A5758"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8594 14.3047H63.4777V3.15845H58.8594V14.3047Z",
    fill: "#D1D0D0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5938 14.3047H63.4786V8.84259H58.5938V14.3047Z",
    fill: "#5A5758"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9957 2.39202C62.7113 2.50442 61.7852 2.83426 61.7852 3.22501V14.1883C61.7852 14.5791 62.7113 14.91 63.9957 15.0234V2.39202Z",
    fill: "#373334"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8347 8.83984H58.8594V5.80924L61.74 3.15571H61.8347V8.83984Z",
    fill: "#999A99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8569 9.10938H58.8594V8.84293H61.8569V9.10938Z",
    fill: "#2D2C2C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M58.184 8.28516H57.1523V6.36063L58.2181 5.30987V6.44773L58.184 6.48144V8.28516Z",
    fill: "#999A99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2189 11.3438H56.8867V8.27965H58.1852V9.10385H58.2189V11.3438Z",
    fill: "#171514"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79297 12.1914L4.97227 12.1914L4.97227 5.26387L6.79297 5.26387L6.79297 12.1914Z",
    fill: "#D1D0D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05859 12.1914L4.97145 12.1914L4.97145 8.28356L7.05859 8.28356L7.05859 12.1914Z",
    fill: "#1A1816"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72656 14.3047L1.1082 14.3047L1.1082 3.15845L5.72656 3.15845L5.72656 14.3047Z",
    fill: "#5A5758"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08594 14.3047L0.467577 14.3047L0.467578 3.15845L5.08594 3.15845L5.08594 14.3047Z",
    fill: "#D1D0D0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35156 14.3047L0.466759 14.3047L0.46676 8.84259L5.35156 8.84259L5.35156 14.3047Z",
    fill: "#5A5758"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000233086 2.39202C1.22345 2.50442 2.10547 2.83426 2.10547 3.22501L2.10547 14.1883C2.10547 14.5791 1.22345 14.91 0.000231981 15.0234L0.000233086 2.39202Z",
    fill: "#373334"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11065 8.83984L5.08594 8.83984L5.08594 5.80924L2.20533 3.15571L2.11065 3.15571L2.11065 8.83984Z",
    fill: "#999A99"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08844 9.10937L5.08594 9.10938L5.08594 8.84293L2.08844 8.84293L2.08844 9.10937Z",
    fill: "#2D2C2C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76128 8.28516L6.79297 8.28516L6.79297 6.36063L5.72719 5.30987L5.72719 6.44773L5.76128 6.48144L5.76128 8.28516Z",
    fill: "#999A99"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72637 11.3437L7.05859 11.3438L7.05859 8.27965L5.76015 8.27965L5.76015 9.10385L5.72637 9.10385L5.72637 11.3437Z",
    fill: "#171514"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2214 8.28125H58.1992V6.47216L58.2214 6.43835V8.28125Z",
    fill: "#77797A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1992 9.10547H58.2214V8.28393H58.1992V9.10547Z",
    fill: "#151412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerAxle);
export default __webpack_public_path__ + "static/media/trailerAxle.bb3c4fa74567f9124265aca0efcb2bcf.svg";
export { ForwardRef as ReactComponent };